import { gql } from '@apollo/client';

export const FOLDER_FRAGMENT = gql`
  fragment FolderFragment on Folder {
    id
    name
    description
    isDefault
    folderGroup {
      id
    }
  }
`;

export const FOLDER_GROUP_FRAGMENT = gql`
  fragment FolderGroupFragment on FolderGroup {
    id
    name
    description
    isUngrouped
  }
`;

export const GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY = gql`
    query Folders($companyId: ID!) {
        folders(companyId: $companyId) {
          ...FolderFragment
        }

        folderGroups(companyId: $companyId) {
          ...FolderGroupFragment
        }
      }
      ${FOLDER_FRAGMENT}
      ${FOLDER_GROUP_FRAGMENT}
`;

export const CREATE_FOLDER_GROUP = gql`
      mutation CreateFolderGroup(
        $name: String!, 
        $description: String, 
        $companyId: ID!
      ) {
      createFolderGroup(
        name: $name, 
        description: $description, 
        companyId: $companyId
      ) {
        folderGroup {
          ...FolderGroupFragment
        }
      }
    }
    ${FOLDER_GROUP_FRAGMENT}
`;

export const UPDATE_FOLDER_GROUP = gql` 
  mutation UpdateFolderGroup($id: ID!, $attributes: FolderGroupAttributes!) {
    updateFolderGroup(id: $id, attributes: $attributes) {
      folderGroup {
        ...FolderGroupFragment
      }
    }
  }
  ${FOLDER_GROUP_FRAGMENT}
`;

export const CREATE_FOLDER = gql`
    mutation CreateFolder(
        $name: String!, 
        $description: String, 
        $folderGroupId: ID!, 
        $companyId: ID!
      ) {
      createFolder(
        name: $name, 
        description: $description, 
        folderGroupId: $folderGroupId, 
        companyId: $companyId
      ) {
        folder {
          ...FolderFragment
        }
      }
    }
    ${FOLDER_FRAGMENT}
`;

export const UPDATE_FOLDER = gql`
  mutation updateFolder($id: ID!, $attributes: FolderAttributes!) {
    updateFolder(id: $id, attributes: $attributes) {
      folder {
          ...FolderFragment
        }
      }
    }
    ${FOLDER_FRAGMENT}
  `;

export const DELETE_FOLDER_GROUP = gql`
  mutation DeleteFolderGroup($id: ID!) {
        deleteFolderGroup(id: $id) {
          void
        }
      }
`;

export const DELETE_FOLDER = gql`
  mutation DeleteFolder($id: ID!) {
        deleteFolder(id: $id) {
          void
        }
      }
`;

export const updateCacheOnCreateFolderGroup = (companyId) => (cache, { data }) => {
  const { createFolderGroup: { folderGroup } } = data;
  const variables = { companyId };
  const { folderGroups: cachedFolderGroups } = cache.readQuery({
    query: GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY,
    variables,
  });
  const folderGroups = [...cachedFolderGroups, folderGroup];
  cache.writeQuery({
    query: GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY,
    variables,
    data: { folderGroups },
  });
};

export const updateCacheOnCreateFolder = (companyId) => (cache, { data }) => {
  const { createFolder: { folder } } = data;
  const variables = { companyId };
  const { folders: cachedFolders } = cache.readQuery({
    query: GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY,
    variables,
  });
  const folders = [...cachedFolders, folder];
  cache.writeQuery({
    query: GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY,
    variables,
    data: { folders },
  });
};
